import type { ReactNode } from 'react';

import type { TIconElement } from '@shared/dream-components';
import { IconElement } from '@shared/dream-components';

interface Props {
  node: TIconElement;
  children: ReactNode | ReactNode[];
}

const Icon = ({ node, children }: Props) => {
  return <IconElement element={node}>{children}</IconElement>;
};

export default Icon;
